export default "__VITE_ASSET__BX8Ub_0C__"